import { Box } from "@mui/material";
import TableHeader from "common/Table/TableHeader";
import React from "react";
import { useState } from "react";
import { GET_ALL_BMI_TRACKS } from "./graphql/query";
import Toaster from "common/Toaster";
import { INITIAL_DATA_TABLE_LIMIT, getFilteredValue } from "utils";
import { useQuery } from "@apollo/client";
import Table from "common/Table";
import LinkTag from "common/LinkTag";
import moment from "moment";
import FilterContainer from "common/FilterElement/FilterContainer";
import FilterInput from "common/FilterElement/FilterInput";
import useDebounce from "utils/useDebounce";
import { useFilterForm } from "common/FilterDrawer/FilterForm";
import FilterClearButton from "common/FilterElement/FilterClearButton";
import CDatePicker from "common/Date";
import CSelect from "common/CSelect";

const WEIGHT_STATUS = [
  {
    display: "Underweight",
    key: "Underweight",
  },
  {
    display: "Healthy Weight",
    key: "healthy weight",
  },
  {
    display: "Overweight",
    key: "Overweight",
  },
  {
    display: "Obesity",
    key: "obesity",
  },
];

const columns = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.2,
    renderCell: ({ row }) => {
      return <LinkTag to={row.objectId}>{row.objectId}</LinkTag>;
    },
  },
  {
    field: "member__user__name",
    headerName: "Member",
    flex: 1,
    renderCell: ({ row }) => {
      return (
        <LinkTag to={`/admin/members/${row?.member?.objectId}`}>
          {row?.member?.user?.name}
        </LinkTag>
      );
    },
  },
  {
    field: "weightStatus",
    headerName: "Weight Status",
    flex: 1,
    sortable: false,
  },

  {
    field: "BMI",
    headerName: "BMI",
    flex: 1,
    sortable: false,
  },
  {
    field: "height",
    headerName: "Height",
    flex: 1,
    valueGetter: function ({ row }) {
      return row.height ? `${row.height.toFixed(2)} cm` : "-";
    },
  },
  {
    field: "weight",
    headerName: "Weight",
    flex: 1,
    valueGetter: function ({ row }) {
      return row.weight ? `${row.weight} kg` : "-";
    },
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    valueGetter: function ({ row }) {
      return moment(row.date).format("DD MMM YYYY");
    },
  },
  {
    field: "createdOn",
    headerName: "Created On",
    flex: 1,
    valueGetter: function ({ row }) {
      return moment(row.createdOn).format("DD MMM YYYY h:mm a");
    },
  },
];

const INITIAL_STATE = {
  weightStart: { type: "text", value: "" },
  weightEnd: { type: "text", value: "" },
  heightEnd: { type: "text", value: "" },
  heightStart: { type: "text", value: "" },
  BMIStart: { type: "text", value: "" },
  BMIEnd: { type: "text", value: "" },
  ageStart: { type: "text", value: "" },
  ageEnd: { type: "text", value: "" },
  // weightStatus: { type: "text", value: "" },
  dateStart: { type: "text", value: null },
  dateEnd: { type: "text", value: null },
};

const BMITracks = () => {
  const [rows, setRows] = useState([]);
  const { filter, setFilter } = useFilterForm(INITIAL_STATE);

  const { loading, data, fetchMore } = useQuery(GET_ALL_BMI_TRACKS, {
    variables: {
      first: INITIAL_DATA_TABLE_LIMIT,
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      const tempRows = res?.BMITracks?.edges?.map((e) => e.node);
      setRows(tempRows);
    },
    onError: (error) => {
      Toaster({
        type: "error",
        message: error.message,
      });
    },
  });

  const debounceFunction = useDebounce((value) => fetchMoreData(value), 500);

  const onClearFilter = () => {
    setFilter(INITIAL_STATE);
    fetchMore({
      variables: {
        first: INITIAL_DATA_TABLE_LIMIT,
      },
    });
  };

  const onChangeDebounce = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "type" && value === "") {
      onClearFilter();
      return;
    }

    let key = name;
    setFilter((state) => ({
      ...filter,
      [key]: { ...state[key], value: value },
    }));

    debounceFunction(
      getFilteredValue({ ...filter, [key]: { ...filter[key], value: value } })
    );
  };

  const fetchMoreData = async (variables) => {
    await fetchMore({
      variables: variables,
    });
  };

  const onDateChangeDebounce = (e, type) => {
    setFilter((state) => ({
      ...filter,
      [type]: {
        ...state[type],
        value: moment(e).format("YYYY-MM-DDT12:00:00"),
      },
    }));

    debounceFunction(
      getFilteredValue({
        ...filter,
        [type]: {
          ...filter[type],
          value: moment(e).format("YYYY-MM-DDT12:00:00"),
        },
      })
    );
  };

  return (
    <Box>
      <TableHeader title="BMI Tracks" />

      <FilterContainer>
        {/* <CSelect
          style={{ width: 200 }}
          listData={WEIGHT_STATUS}
          display="display"
          value="key"
          label="Weight Type"
          size="small"
          name="weightStatus"
          selectValue={filter["weightStatus"].value}
          onChange={onChangeDebounce}
        /> */}

        <FilterInput
          label="Weight Start"
          name="weightStart"
          value={filter["weightStart"].value}
          onChange={onChangeDebounce}
        />

        <FilterInput
          label="Weight End"
          name="weightEnd"
          value={filter["weightEnd"].value}
          onChange={onChangeDebounce}
        />
        <FilterInput
          label="Height Start"
          name="heightStart"
          value={filter["heightStart"].value}
          onChange={onChangeDebounce}
        />
        <FilterInput
          label="Height End"
          name="heightEnd"
          value={filter["heightEnd"].value}
          onChange={onChangeDebounce}
        />
        <FilterInput
          label="BMI Start"
          name="BMIStart"
          value={filter["BMIStart"].value}
          onChange={onChangeDebounce}
        />
        <FilterInput
          label="BMI End"
          name="BMIEnd"
          value={filter["BMIEnd"].value}
          onChange={onChangeDebounce}
        />

        <CDatePicker
          label="Start Date"
          size="small"
          value={filter["dateStart"].value}
          onChange={(e) => onDateChangeDebounce(e, "dateStart")}
        />
        <CDatePicker
          label="End Date"
          size="small"
          value={filter["dateEnd"].value}
          onChange={(e) => onDateChangeDebounce(e, "dateEnd")}
        />

        <FilterClearButton onClick={onClearFilter} />
      </FilterContainer>

      <Table
        columns={columns}
        rows={rows}
        loading={loading}
        isHiddenColumnFeature={true}
        fetchMore={fetchMore}
        totalCount={data?.BMITracks?.totalCount}
        rowHeight={70}
      />
    </Box>
  );
};

export default BMITracks;
